"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var index_1 = require("./index");

exports.TitleWithMargin = styled_components_1.default(index_1.Title)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-bottom: 20px;\n"], ["\n    margin-bottom: 20px;\n"])));
var templateObject_1;